import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const notificationDefaultVariants = {
  "variant": "success",
  "kind": "temporary"
}
const notificationCompoundVariants = []

const notificationSlotNames = [
  [
    "root",
    "Notification__root"
  ],
  [
    "icon",
    "Notification__icon"
  ],
  [
    "cta",
    "Notification__cta"
  ],
  [
    "content",
    "Notification__content"
  ]
]
const notificationSlotFns = /* @__PURE__ */ notificationSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, notificationDefaultVariants, getSlotCompoundVariant(notificationCompoundVariants, slotName))])

const notificationFn = memo((props = {}) => {
  return Object.fromEntries(notificationSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const notificationVariantKeys = [
  "kind",
  "variant"
]
const getVariantProps = (variants) => ({ ...notificationDefaultVariants, ...compact(variants) })

export const notification = /* @__PURE__ */ Object.assign(notificationFn, {
  __recipe__: false,
  __name__: 'notification',
  raw: (props) => props,
  variantKeys: notificationVariantKeys,
  variantMap: {
  "kind": [
    "temporary",
    "persistent"
  ],
  "variant": [
    "success",
    "danger",
    "progress"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, notificationVariantKeys)
  },
  getVariantProps
})